import { Component, EventEmitter, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { PointStoreProductOrderService } from 'src/app/gamification/marketplace/agent-side/services/point-store-product-order.service';
import { ShoppingCartService } from 'src/app/gamification/marketplace/agent-side/services/shopping-cart.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { CvMarketplaceShoppingCartComponent } from '../cv-marketplace-shopping-cart/cv-marketplace-shopping-cart.component';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import OverlayScrollbars from 'overlayscrollbars';

@Component({
  selector: 'cv-marketplace-shopping-cart-orders',
  templateUrl: './cv-marketplace-shopping-cart-orders.component.html',
  styleUrls: ['./cv-marketplace-shopping-cart-orders.component.scss']
})
export class CvMarketplaceShoppingCartOrdersComponent implements OnInit {

  @Output() clearSearch = new EventEmitter<string>();
  _localizationStrings = new Map();
  pspos: any = null;
  pscs: any = null;
  isLoading: boolean = true;
  allowedQuantity: number = 20;
  variantDescription = 'Variant';

  public isCxOne: boolean = false;
  reorderNumberOfProductsToAdd: number = 1;

  ordersClientSide = [];
  ordersClientSidePosition = 1;
  ordersClientSideNumberOfItems = 30;
  isFirstTimeLoading: boolean = true;
  isLoadingClientSide: boolean = false;
  isTabClickedInProcess: boolean = false;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private cvLocalizationService: CVLocalizationService,
    private pointStoreProductOrderService: PointStoreProductOrderService,
    private cvNumberLocalize: CvNumberLocalizePipe,
    private sanitizer: DomSanitizer,
    private customDialogService: CvCustomDialogService,
    private cvConfigurationService: CvConfigurationService,
    private marketplaceShoppingCartComponent: CvMarketplaceShoppingCartComponent,
    private ref: ChangeDetectorRef
  ) {
    this.pspos = pointStoreProductOrderService.pointStoreProductOrderObj;
    this.pscs = shoppingCartService.shoppingCartObj;
    this.isCxOne = cvConfigurationService.isCxOne;
  }

  ngOnInit(): void {
    this.pscs.shoppingCartActiveTab = 'ORDERS';
    this.pscs.shoppingCartIsProductSelected = false;
    this.clearSearch.emit();
    this.loadLocalizations();
    this.loadOrdersHistory();
  }

  async loadOrdersHistory() {
    await this.shoppingCartService.getLandingInfo();
    await this.pointStoreProductOrderService.LoadPointStoreProductHistoryOrders();
    if (this.pspos.historyOrders != null) {
      this.pspos.historyOrders = [...this.pspos.historyOrders.sort((a, b) => (a.PointStoreOrderID > b.PointStoreOrderID ? -1 : 1))];
      await this.loadLocalizations();
    }
    this.getNextElementsFromArray();
  }

  loadLocalizations() {
    this.cvLocalizationService.GetSection("MarketPlace").then((map) => {
      this._localizationStrings = map;
    });
  }

  getLocalizationString(key, defaultValue) {
    if (this._localizationStrings && this._localizationStrings.has(key))
      return this._localizationStrings.get(key);
    return defaultValue;
  }

  toggled(event) {
  }
  filterScrollOptions: OverlayScrollbars.PartialOptions = {
    scrollbars: {
      visibility: 'visible',
      autoHide: "leave",
      autoHideDelay: 100,
      theme:"custom-scrollbar"
    },
    overflow: {
      x: 'hidden',
      y: 'scroll'
    },
  };
  getImageSrc(item): string {
    let imageSrc = '';
    if(item != null && this.pscs.pointStoreProducts != null){
      let matchedProduct = this.pscs.pointStoreProducts.find((p) => { return p.PointStoreProductID == item._PointStoreProductOrderedDTO.PointStoreProductID; });

      if(item._PointStoreProductOrderedDTO.ProductImageID != null && item._PointStoreProductOrderedDTO.ProductImageID > 0){
        if (item._PointStoreProductOrderedDTO.Variation != null && item._PointStoreProductOrderedDTO.Variation > 0) {

          if (matchedProduct != null && matchedProduct.MultipleImagesData != null) {
            let variationImageData = matchedProduct.MultipleImagesData.find((mp) => { return mp.PointStoreProductVariationID == item._PointStoreProductOrderedDTO.Variation; })
            if (variationImageData != null && variationImageData.PointStoreProductImageID != null && variationImageData.PointStoreProductImageID > 0){
              imageSrc = '../Admin/ImageResizer.aspx?imgid=' + variationImageData.PointStoreProductImageID + '&w=auto&h=200';
            }             
            else {
              imageSrc = '../Admin/ImageResizer.aspx?imgid=' + item._PointStoreProductOrderedDTO.ProductImageID + '&w=auto&h=200';
            }          
          } else {
            imageSrc = '../Admin/ImageResizer.aspx?imgid=' + item._PointStoreProductOrderedDTO.ProductImageID + '&w=auto&h=200';
          }
        } else{
          imageSrc = '../Admin/ImageResizer.aspx?imgid=' + item._PointStoreProductOrderedDTO.ProductImageID + '&w=auto&h=200';
        }
      } else {
        if(item._PointStoreProductOrderedDTO.Variation != null && item._PointStoreProductOrderedDTO.Variation > 0){

          if (matchedProduct != null && matchedProduct.MultipleImagesData != null) {
            let variationImageData = matchedProduct.MultipleImagesData.find((mp) => { return mp.PointStoreProductVariationID == item._PointStoreProductOrderedDTO.Variation; })
            if (variationImageData != null && variationImageData.PointStoreProductImageID != null && variationImageData.PointStoreProductImageID > 0){
              imageSrc = '../Admin/ImageResizer.aspx?imgid=' + variationImageData.PointStoreProductImageID + '&w=auto&h=200';
            }             
            else {
              imageSrc =  '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80';
            }          
          } else {
            imageSrc =  '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80'; 
          }
      } else {
        imageSrc =  '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80'; 
      }
    }
  } else {
    imageSrc =  '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80'; 
  }

    return imageSrc;
  }

  isEmptyOrNullVariation(product): boolean{
    let status = false;
    if(product.Variation == null || product.Variation == 0 || this.pscs.pointStoreProducts == null || product.PointStoreProductID == null || product.PointStoreProductID == 0){
      status = true;
    } else{
      let matchedProduct = this.pscs.pointStoreProducts.find((p) => { return p.PointStoreProductID == product.PointStoreProductID});
      if (matchedProduct != null && matchedProduct.MultipleImagesData != null) {
        let variationImageData = matchedProduct.MultipleImagesData.find((mp) => { return mp.PointStoreProductVariationID == product.Variation; });
        if (variationImageData != null && variationImageData.PointStoreProductImageID != null && variationImageData.PointStoreProductImageID > 0){
          status = false;
        } else {
          status = true;
        }
      } else {
        status = true;
      }
    }
    return status;
  }

  getVariationName(item): string {
    let variationName = '';
    if (this.pscs) {
      variationName = this.pscs.pointStoreProducts.find(x => x.PointStoreProductID == item._PointStoreProductOrderedDTO.PointStoreProductID) == null ? '' : this.pscs.pointStoreProducts.find(x => x.PointStoreProductID == item._PointStoreProductOrderedDTO.PointStoreProductID).VariationName;
      if(variationName == '' && item._PointStoreProductOrderedDTO.Variation != null && item._PointStoreProductOrderedDTO.Variation > 0){
        variationName = this.getLocalizationString(this.variantDescription, this.variantDescription);
      }
    }
    return variationName;
  }

  getVariationDescription(item): string {
    let variationDescription = '';
    variationDescription = item._PointStoreProductOrderedDTO.VariationName != null && item._PointStoreProductOrderedDTO.VariationName != '' ? item._PointStoreProductOrderedDTO.VariationName : 'N/A';
    return variationDescription;
  }

  getOrderTotal(value): string {
    let orderTotal = '';
    orderTotal = this.cvNumberLocalize.transform(value);
    return orderTotal;
  }

  getStatus(item): any {
    let status = {
      name: '',
      keyLocalization: '',
      value: 0,
      icon: '',
      color: '',
      iconHTML: null,
    };
    if (this.pspos) {
      let itemStatus = this.pspos.OrderStatus.find(s => s.value == item._PointStoreProductOrderedDTO.ProductStatus);
      if (itemStatus) {
        status.name = itemStatus.name;
        status.keyLocalization = itemStatus.keyLocalization;
        status.value = itemStatus.value;
        switch (status.value) {
          case 1:
            //Processing
            status.icon = 'generate-schedule';
            status.color = 'ohp-status-icon-yellow';
            break;
          case 2:
            //In transit
            status.icon = 'up-down-arrows';
            status.color = 'ohp-status-icon-gray';
            break;
          case 3:
            //Ready for pick-up
            status.icon = 'box-ready-pick-up'
            status.color = 'ohp-status-icon-gray'
            break;
          case 4:
            //Complete
            status.icon = 'status-completed'
            status.color = 'ohp-status-icon-green'
            break;
          case 5:
            //Cancelled
            status.icon = 'status-failed'
            status.color = 'ohp-status-icon-red'
            break;
          case 6:
            //Shipped
            status.icon = 'truck'
            status.color = 'ohp-status-icon-gray'
            break;
          default:
            break;
        }

        if (this.sanitizer != null){
          status.iconHTML = this.sanitizer.bypassSecurityTrustHtml(`<use href="../App_Themes/CXone/icons/${status.icon}.svg#${status.icon}"></use>`);
        }
      }
    }
    return status;
  }

  allowBuyAgain(itemID, variation): boolean {
    //Verify that the item still exists. 
    //  If it does and has a quantity > 0 (or a quantity that isn't null), return true.
    let filteredItems = this.pscs.pointStoreProducts.filter(function (e) { return e.PointStoreProductID == itemID; });
    let matchedItem = null;
    let matchedVariation = null;

    if (filteredItems.length > 0) {
      matchedItem = filteredItems[0];
    } else {
      return false; //No items matched
    }

    if (matchedItem != null && matchedItem.HasProductVariations && matchedItem.VariationsData.length) {
      matchedVariation = matchedItem.VariationsData.find((v) => { return v.PointStoreProductVariationID == variation; });
      if (matchedVariation == null)
        return false;
    } else if (matchedItem != null && variation != null && variation > 0){
      //the added item has variation, but the variations have been removed.
      return false;
    }

    return matchedVariation != null ? (matchedVariation.VariationQuantity == null || matchedVariation.VariationQuantity > 0) : (matchedItem.Quantity == null || matchedItem.Quantity > 0);
  };

  async reorderProduct(orderedProduct) {
    this.pscs.shoppingCartShowLoader = true;

    //Check session cart
    await this.shoppingCartService.getSessionCart();
    
    if(!this.checkAvailityToAddItemsToCart(orderedProduct, this.reorderNumberOfProductsToAdd, orderedProduct.Variation)){
      this.pscs.shoppingCartShowLoader = false;
      return;
    }

    let productInfo = this.pscs.pointStoreProducts.filter((p) => {
      return p.PointStoreProductID == orderedProduct.PointStoreProductID;
    });

    this.shoppingCartService.addProductsToCart(productInfo[0], this.reorderNumberOfProductsToAdd, orderedProduct.Variation).then((result: any) => {
      if(result){
        this.pscs.pointStoreVisibleContent.showPopUpAddedCart = true;
        this.marketplaceShoppingCartComponent.addCartProduct();
        this.pscs.shoppingCartShowLoader = false;
      } else{
        this.pscs.shoppingCartShowLoader = false;
      }
    });
  }

  checkAvailityToAddItemsToCart(product, quantity, variationId): boolean {
    let isAvaliable: boolean = true;
    let totalItems: number = 0;
    
    //It is a product with variation or not
    let productCart = variationId == null ? 
        this.pscs.pointStoreCart.pointStoreProducts.find( x => x.ProductID == product.PointStoreProductID) :
        this.pscs.pointStoreCart.pointStoreProducts.find( x => x.ProductID == product.PointStoreProductID && x.Variation == variationId);

    //Is the product in the cart?
    if(productCart){
      totalItems = productCart.Quantity + Number(quantity);
      isAvaliable = totalItems > this.allowedQuantity ? false: true;
    } else {
      totalItems = quantity;
      isAvaliable = totalItems > this.allowedQuantity ? false: true;
    }

    //Not available?
    if(!isAvaliable && this.customDialogService != null){
      if(this.cvConfigurationService.isCxOne){
        this.customDialogService.showDialog(
          this.getLocalizationString("Warning_Text", "Warning"),
          this.getLocalizationString("Quantity_Added_Exceeds_Permitted_Limit", 'The quantity added exceeds the permitted limit.'),
          1,
          '',
          this.getLocalizationString("Ok", "Ok"),
          true,
          () => { },
          () => { }
        );
      } else{
        showErrorMessage(this.getLocalizationString("Quantity_Added_Exceeds_Permitted_Limit", 'The quantity added exceeds the permitted limit.'));
      }
    }
    
    return isAvaliable;
  }

  isPriceChanged(data): boolean{
    let pricedChanged = false;
    let product = this.pscs.pointStoreProducts.find((elem) => { return elem.PointStoreProductID == data._PointStoreProductOrderedDTO.PointStoreProductID; });
    if(product){
      if(product.HasVariationPrices && product.VariationsData){
          let variationData = product.VariationsData.find(i => {return i.PointStoreProductVariationID == data._PointStoreProductOrderedDTO.Variation});
          if(variationData){
            if(data._PointStoreProductOrderedDTO.ProductCost != variationData.VariationPrice){
              pricedChanged = true;
            }
          }
      } else {
        if(data._PointStoreProductOrderedDTO.ProductCost != product.Price){
          pricedChanged = true;
        }
      }
    }
    return pricedChanged
  }

  getNextElementsFromArray(): void{
    if(this.ordersClientSide.length < this.pspos.historyOrders.length){
      const arrayToAssing = this.pspos.historyOrders.slice((this.ordersClientSidePosition * this.ordersClientSideNumberOfItems) - this.ordersClientSideNumberOfItems,
                                                           this.ordersClientSideNumberOfItems * this.ordersClientSidePosition);

      this.ordersClientSide.push(...arrayToAssing);
      this.ordersClientSidePosition++;
      this.isLoading = false;

      if(this.isFirstTimeLoading){
        this.isFirstTimeLoading = false;
      } else {
        this.isLoadingClientSide = true;
        this.ref.detectChanges();
        this.isLoadingClientSide = false;
      }
    } else {
      this.isLoading = false;
    }
  }


  scrollEvent() {
    let scrollElements = document.querySelectorAll('[data-overlayscrollbars-viewport="scrollbarHidden"]');
    if (scrollElements) {
      if (scrollElements.length > 0) {
        let ordersScroll = scrollElements[1] as HTMLElement;
        if (Math.round(ordersScroll.scrollTop) == (ordersScroll.scrollHeight - ordersScroll.offsetHeight)) {
          this.getNextElementsFromArray();
        }
      }
    }
  }


  customToggleEvent(id: string, event: any): void {
    if(this.checkIfHeaderAccordionClicked(id, event)){
      this.isTabClickedInProcess = true;
      let tab = document.querySelector('#'+ id + '> div');
      let tabContainer = document.querySelector('#'+ id + '> div > div:nth-child(2)') as HTMLElement;
       tabContainer.classList.add('tb-body-expand-animation');
  
      //hide tab
      if(tab.classList.contains('selected')){
       tab.classList.remove('selected');
       tabContainer.style.height = '0px';
       setTimeout(() => {
         tabContainer.classList.remove('tb-body-expand-animation');
         this.isTabClickedInProcess = false;
       }, 500);
      } else {
       //active tab
       tab.classList.add('selected');
       tabContainer.style.height = this.calculateHeightByOrderItems(id) + 'px';
       setTimeout(() => {
         tabContainer.classList.remove('tb-body-expand-animation');
         tabContainer.style.height = null;
         this.isTabClickedInProcess = false;
       }, 500);
      }
    }
  }

  checkIfHeaderAccordionClicked(id, event): boolean{

    if(this.isTabClickedInProcess){return false;}

    let isValid = false;
    const tabElement = document.querySelector('#'+ id + '> div > div:nth-child(1)') as HTMLElement;
    if(tabElement.contains(event.target)){
      isValid = true;
    }
    return isValid;
   }
  
   calculateHeightByOrderItems(id): number{
    let totalHeight = 0;
    const tabItems = document.querySelectorAll('#'+ id + '> div > div:nth-child(2) > div.body-order-history-row') as NodeListOf<HTMLElement>;
    for (let index = 0; index < tabItems.length; index++) {
      const element = tabItems[index];
      totalHeight += element.offsetHeight;
    }
    return totalHeight;
   }

}
